var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResize(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    baseProfile: "tiny-ps",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 32",
    width: 20,
    height: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M13 8L15 8L15 25L13 25C12.74 25 12.48 24.95 12.23 24.85C11.99 24.75 11.77 24.6 11.59 24.41C11.4 24.23 11.25 24.01 11.15 23.77C11.05 23.52 11 23.26 11 23L11 10C11 9.74 11.05 9.48 11.15 9.23C11.25 8.99 11.4 8.77 11.59 8.59C11.77 8.4 11.99 8.25 12.23 8.15C12.48 8.05 12.74 8 13 8L13 8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 13.46L8 19.37C8 19.46 7.97 19.55 7.92 19.62C7.87 19.7 7.8 19.76 7.72 19.79C7.63 19.83 7.54 19.83 7.45 19.82C7.36 19.8 7.28 19.76 7.22 19.69L4.26 16.74C4.22 16.7 4.18 16.65 4.16 16.59C4.14 16.54 4.13 16.48 4.13 16.41C4.13 16.35 4.14 16.29 4.16 16.24C4.18 16.18 4.22 16.13 4.26 16.09L7.22 13.14C7.28 13.07 7.36 13.03 7.45 13.01C7.54 12.99 7.63 13 7.71 13.04C7.8 13.07 7.87 13.13 7.92 13.2C7.97 13.28 8 13.37 8 13.46L8 13.46Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResize);
export default __webpack_public_path__ + "static/media/resize.46e3a2e78bfac2cea9f9ff641a74c7ce.svg";
export { ForwardRef as ReactComponent };